import React from 'react'
import { Paper } from '@mui/material'
import styles from './Tag.module.scss'

export default function Tag({label}) {
  return (
    <Paper className={styles['root']} elevation={0}>
        {label}
    </Paper>
  )
}